import { Controller } from "@hotwired/stimulus";

export class AccordionController extends Controller {
  static targets = ["panel", "icon"];

  connect() {
    this.open = !this.panelTarget.classList.contains("hidden");
    this._updateIcon();
  }

  toggle() {
    this.open = !this.open;
    this.panelTarget.classList.toggle("hidden", !this.open);
    this._updateIcon();
  }

  _updateIcon() {
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180", !this.open);
    }
  }
}
